let CurrencyCode;

(function (CurrencyCode) {
  CurrencyCode["Usd"] = "USD";
  CurrencyCode["Eur"] = "EUR";
  CurrencyCode["Gbp"] = "GBP";
  CurrencyCode["Cad"] = "CAD";
  CurrencyCode["Afn"] = "AFN";
  CurrencyCode["All"] = "ALL";
  CurrencyCode["Dzd"] = "DZD";
  CurrencyCode["Aoa"] = "AOA";
  CurrencyCode["Ars"] = "ARS";
  CurrencyCode["Amd"] = "AMD";
  CurrencyCode["Awg"] = "AWG";
  CurrencyCode["Aud"] = "AUD";
  CurrencyCode["Bbd"] = "BBD";
  CurrencyCode["Azn"] = "AZN";
  CurrencyCode["Bdt"] = "BDT";
  CurrencyCode["Bsd"] = "BSD";
  CurrencyCode["Bhd"] = "BHD";
  CurrencyCode["Bif"] = "BIF";
  CurrencyCode["Byn"] = "BYN";
  CurrencyCode["Bzd"] = "BZD";
  CurrencyCode["Bmd"] = "BMD";
  CurrencyCode["Btn"] = "BTN";
  CurrencyCode["Bam"] = "BAM";
  CurrencyCode["Brl"] = "BRL";
  CurrencyCode["Bob"] = "BOB";
  CurrencyCode["Bwp"] = "BWP";
  CurrencyCode["Bnd"] = "BND";
  CurrencyCode["Bgn"] = "BGN";
  CurrencyCode["Mmk"] = "MMK";
  CurrencyCode["Khr"] = "KHR";
  CurrencyCode["Cve"] = "CVE";
  CurrencyCode["Kyd"] = "KYD";
  CurrencyCode["Xaf"] = "XAF";
  CurrencyCode["Clp"] = "CLP";
  CurrencyCode["Cny"] = "CNY";
  CurrencyCode["Cop"] = "COP";
  CurrencyCode["Kmf"] = "KMF";
  CurrencyCode["Cdf"] = "CDF";
  CurrencyCode["Crc"] = "CRC";
  CurrencyCode["Hrk"] = "HRK";
  CurrencyCode["Czk"] = "CZK";
  CurrencyCode["Dkk"] = "DKK";
  CurrencyCode["Djf"] = "DJF";
  CurrencyCode["Dop"] = "DOP";
  CurrencyCode["Xcd"] = "XCD";
  CurrencyCode["Egp"] = "EGP";
  CurrencyCode["Ern"] = "ERN";
  CurrencyCode["Etb"] = "ETB";
  CurrencyCode["Fkp"] = "FKP";
  CurrencyCode["Xpf"] = "XPF";
  CurrencyCode["Fjd"] = "FJD";
  CurrencyCode["Gmd"] = "GMD";
  CurrencyCode["Ghs"] = "GHS";
  CurrencyCode["Gip"] = "GIP";
  CurrencyCode["Gtq"] = "GTQ";
  CurrencyCode["Gnf"] = "GNF";
  CurrencyCode["Gyd"] = "GYD";
  CurrencyCode["Gel"] = "GEL";
  CurrencyCode["Htg"] = "HTG";
  CurrencyCode["Hnl"] = "HNL";
  CurrencyCode["Hkd"] = "HKD";
  CurrencyCode["Huf"] = "HUF";
  CurrencyCode["Isk"] = "ISK";
  CurrencyCode["Inr"] = "INR";
  CurrencyCode["Idr"] = "IDR";
  CurrencyCode["Irr"] = "IRR";
  CurrencyCode["Ils"] = "ILS";
  CurrencyCode["Iqd"] = "IQD";
  CurrencyCode["Jmd"] = "JMD";
  CurrencyCode["Jpy"] = "JPY";
  CurrencyCode["Jep"] = "JEP";
  CurrencyCode["Jod"] = "JOD";
  CurrencyCode["Kid"] = "KID";
  CurrencyCode["Kzt"] = "KZT";
  CurrencyCode["Kes"] = "KES";
  CurrencyCode["Kwd"] = "KWD";
  CurrencyCode["Kgs"] = "KGS";
  CurrencyCode["Lak"] = "LAK";
  CurrencyCode["Lvl"] = "LVL";
  CurrencyCode["Lbp"] = "LBP";
  CurrencyCode["Lsl"] = "LSL";
  CurrencyCode["Lrd"] = "LRD";
  CurrencyCode["Lyd"] = "LYD";
  CurrencyCode["Ltl"] = "LTL";
  CurrencyCode["Mga"] = "MGA";
  CurrencyCode["Mkd"] = "MKD";
  CurrencyCode["Mop"] = "MOP";
  CurrencyCode["Mwk"] = "MWK";
  CurrencyCode["Mvr"] = "MVR";
  CurrencyCode["Mxn"] = "MXN";
  CurrencyCode["Myr"] = "MYR";
  CurrencyCode["Mru"] = "MRU";
  CurrencyCode["Mur"] = "MUR";
  CurrencyCode["Mdl"] = "MDL";
  CurrencyCode["Mad"] = "MAD";
  CurrencyCode["Mnt"] = "MNT";
  CurrencyCode["Mzn"] = "MZN";
  CurrencyCode["Nad"] = "NAD";
  CurrencyCode["Npr"] = "NPR";
  CurrencyCode["Ang"] = "ANG";
  CurrencyCode["Nzd"] = "NZD";
  CurrencyCode["Nio"] = "NIO";
  CurrencyCode["Ngn"] = "NGN";
  CurrencyCode["Nok"] = "NOK";
  CurrencyCode["Omr"] = "OMR";
  CurrencyCode["Pkr"] = "PKR";
  CurrencyCode["Pab"] = "PAB";
  CurrencyCode["Pgk"] = "PGK";
  CurrencyCode["Pyg"] = "PYG";
  CurrencyCode["Pen"] = "PEN";
  CurrencyCode["Php"] = "PHP";
  CurrencyCode["Pln"] = "PLN";
  CurrencyCode["Qar"] = "QAR";
  CurrencyCode["Ron"] = "RON";
  CurrencyCode["Rub"] = "RUB";
  CurrencyCode["Rwf"] = "RWF";
  CurrencyCode["Wst"] = "WST";
  CurrencyCode["Shp"] = "SHP";
  CurrencyCode["Sar"] = "SAR";
  CurrencyCode["Std"] = "STD";
  CurrencyCode["Rsd"] = "RSD";
  CurrencyCode["Scr"] = "SCR";
  CurrencyCode["Sll"] = "SLL";
  CurrencyCode["Sgd"] = "SGD";
  CurrencyCode["Sos"] = "SOS";
  CurrencyCode["Sdg"] = "SDG";
  CurrencyCode["Syp"] = "SYP";
  CurrencyCode["Zar"] = "ZAR";
  CurrencyCode["Krw"] = "KRW";
  CurrencyCode["Ssp"] = "SSP";
  CurrencyCode["Sbd"] = "SBD";
  CurrencyCode["Lkr"] = "LKR";
  CurrencyCode["Srd"] = "SRD";
  CurrencyCode["Szl"] = "SZL";
  CurrencyCode["Sek"] = "SEK";
  CurrencyCode["Chf"] = "CHF";
  CurrencyCode["Tjs"] = "TJS";
  CurrencyCode["Twd"] = "TWD";
  CurrencyCode["Thb"] = "THB";
  CurrencyCode["Tzs"] = "TZS";
  CurrencyCode["Top"] = "TOP";
  CurrencyCode["Ttd"] = "TTD";
  CurrencyCode["Tnd"] = "TND";
  CurrencyCode["Try"] = "TRY";
  CurrencyCode["Tmt"] = "TMT";
  CurrencyCode["Ugx"] = "UGX";
  CurrencyCode["Uah"] = "UAH";
  CurrencyCode["Aed"] = "AED";
  CurrencyCode["Uyu"] = "UYU";
  CurrencyCode["Uzs"] = "UZS";
  CurrencyCode["Vuv"] = "VUV";
  CurrencyCode["Ves"] = "VES";
  CurrencyCode["Vnd"] = "VND";
  CurrencyCode["Xof"] = "XOF";
  CurrencyCode["Yer"] = "YER";
  CurrencyCode["Zmw"] = "ZMW";
  CurrencyCode["Byr"] = "BYR";
  CurrencyCode["Vef"] = "VEF";
})(CurrencyCode || (CurrencyCode = {}));

export { CurrencyCode };
